import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { IStatusData } from 'src/app/shared/interfaces/statuses-map';
import { getStatusData } from 'src/app/shared/utils/tickets-table-utils';
import { ManagedServicesRepository } from '../../../../services/managed-services-repository.service';
import { IMspParentChildTicket } from '../../../interfaces/msp-parent-child-ticket';
import { IMspStatusData } from '../../../interfaces/msp-statuses-map';
import { MspTicket } from '../../../interfaces/msp-ticket';

@Component({
  selector: 'msp-ticket-detail-parent',
  templateUrl: './ticket-detail-parent.component.html',
  styleUrls: ['./ticket-detail-parent.component.scss'],
  standalone: false,
})
export class TicketDetailParentComponent implements OnInit {
  /** Hold parent ticket data */
  @Input() parentTicketData: IMspParentChildTicket;

  /** Hold ticket details */
  @Input() ticketDetails: MspTicket;

  /** Hold loading state for parent ticket Card*/
  @Input() isLoadingParentTicket: boolean;

  /** Hold msp status map for ticket header */
  @Input() statusMap: IStatusData[];

  /** Hold flag to show when fetching parent ticket fails */
  @Input() apiParentTicketFailed: boolean;

  /** Object to hold MSP status data */
  mspStatusData: IMspStatusData;

  constructor(private managedServiceRepository: ManagedServicesRepository) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isLoadingParentTicket'] &&
      !changes['isLoadingParentTicket'].currentValue &&
      changes['isLoadingParentTicket'].previousValue
    ) {
      this.mspStatusData = getStatusData(
        this.parentTicketData.statusName,
        this.parentTicketData.boardName,
        this.statusMap,
      );
    }
  }

  /**
   * Retry fetching parent ticket
   */
  retryFetchParentTicket() {
    this.apiParentTicketFailed = false;
    this.isLoadingParentTicket = true;

    // Assuming the parent ticket ID is available from the current ticket
    // You might need to adjust this based on how your application stores the parent ticket ID
    this.managedServiceRepository
      .getTicketParentDetail(Number(this.ticketDetails?.parentTicketId))
      .pipe(
        finalize(() => {
          this.isLoadingParentTicket = false;
        }),
      )
      .subscribe({
        next: (parentTicket) => {
          this.parentTicketData = parentTicket;
          this.mspStatusData = getStatusData(
            this.parentTicketData.statusName,
            this.parentTicketData.boardName,
            this.statusMap,
          );
          this.apiParentTicketFailed = false;
        },
        error: (error) => {
          console.error('Failed to fetch parent ticket', error);
          this.apiParentTicketFailed = true;
        },
      });
  }
}
